module.exports = __webpack_public_path__ + "img/802.f6f2701b.gif";